import * as React from "react";
import Modal from "../ui/modal/Modal";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./confirmSendBillModal.scss";
import ButtonSecondary from "../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
	/**
	 * Indicates if request to server is in progress.
	 */
	isLoading: boolean;
}

type Props = ComponentProps;

export default class ConfirmSendBillModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal customClass={"c-confirm-send-modal"} onCloseClicked={this.props.onClose} title={"Send partner’s bill?"} autoWidth={true}>
				<div className="c-confirm-send-modal_container">
					<p>An email will be sent via Xero.</p>
					<div className="c-confirm-send-modal_buttons-container">
						<div className={"pull-right"}>
							<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
							<ButtonPrimary label={"Send bill"} onClick={this.props.onConfirm} disabled={this.props.isLoading}/>
						</div>
					</div>
				</div>
			</Modal>
		)
	}
}
